// 🔴 L2 (N°876) — saisie d'un SITE : le lieu RÉEL d'une affaire.
// ⛔ Aucun site inventé : l'adresse et la ville sont obligatoires, rien n'est
// déduit du client.
import { useState } from "react";

const CHAMP = { height: 36, borderRadius: 8, padding: "0 10px", width: "100%",
                border: "0.5px solid var(--oh-border)",
                background: "var(--oh-bg-surface)", color: "var(--oh-text)" };

export function SiteForm({ onValider, onAnnuler, occupe = false, libelleBouton = "Créer le site", initial = null }) {
  const [v, setV] = useState({ nom_site: initial?.nom_site || "", adresse: initial?.adresse || "", code_postal: initial?.code_postal || "", ville: initial?.ville || "" });
  const champ = (cle, ph) => (
    <input value={v[cle]} placeholder={ph} aria-label={ph} data-testid={`site-${cle}`}
           onChange={(ev) => setV((x) => ({ ...x, [cle]: ev.target.value }))} style={CHAMP} />
  );
  const complet = v.adresse.trim() && v.ville.trim();
  return (
    <div className="space-y-2" data-testid="site-form">
      {champ("nom_site", "Nom du site (ex. Résidence Les Tilleuls — bât. B)")}
      {champ("adresse", "Adresse du site")}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {champ("code_postal", "Code postal")}
        <div className="sm:col-span-2">{champ("ville", "Ville")}</div>
      </div>
      <div className="flex gap-2">
        <button type="button" disabled={!complet || occupe} data-testid="site-valider"
                onClick={() => onValider({ nom_site: initial ? v.nom_site.trim() : (v.nom_site.trim() || undefined),
                                           adresse: v.adresse.trim(),
                                           code_postal: initial ? v.code_postal.trim() : (v.code_postal.trim() || undefined),
                                           ville: v.ville.trim() })}
                className="rounded-lg px-3 text-sm disabled:opacity-60"
                style={{ height: 36, background: "var(--oh-accent-solid)",
                         color: "var(--oh-accent-contrast)" }}>
          {libelleBouton}
        </button>
        {onAnnuler && (
          <button type="button" onClick={onAnnuler} className="rounded-lg px-3 text-sm"
                  style={{ height: 36, background: "transparent",
                           border: "0.5px solid var(--oh-border)",
                           color: "var(--oh-text-secondary)" }}>
            Annuler
          </button>
        )}
      </div>
    </div>
  );
}

export default SiteForm;
